import { FC } from "react"
import { X } from "lucide-react"
import { Button } from "../ui/button"

type CategoryTagProps = {
  label: string
  onDelete?: () => void
  onClick?: () => void
}

export const CategoryTag: FC<CategoryTagProps> = ({ label, onDelete, onClick }) => {
  return (
    <div
      className={`inline-flex items-center gap-2 px-4 py-2 bg-sumoPrimary dark:bg-sumoPrimary/90 rounded-full shadow-soft hover:shadow-yellow transition-all duration-200 ${onClick ? 'cursor-pointer hover:scale-105' : ''}`}
      onClick={onClick}
    >
      <span className="text-sm font-semibold text-sumoNavy dark:text-sumoNavy">
        {label}
      </span>
      {onDelete && (
        <Button
          variant="ghost"
          size="icon"
          className="h-5 w-5 rounded-full hover:bg-sumoNavy/10 dark:hover:bg-sumoNavy/20 p-0"
          onClick={(e) => {
            e.stopPropagation()
            onDelete()
          }}
        >
          <X className="text-sumoNavy dark:text-sumoNavy" width={14} height={14} />
        </Button>
      )}
    </div>
  )
}
